// ABOUTME: Modal for moving a cost rule to a specific step/position in the list.
// ABOUTME: Shows the current step and lets the user enter a new step; reorders the rules locally on confirm.
import { Box, useTheme } from "@mui/material";
import { arrayMove } from "@dnd-kit/sortable";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import Subheading from "../../theme/text/Subheading";
import Heading from "../../theme/text/Heading";
import Text from "../../theme/text/Text";
import TextInput from "../../theme/inputs/TextInput";
import { tokens } from "../../../theme";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const MMoveCostRule = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const total = props.costRules?.length ?? 0;
    const currentStep = props.fromIndex !== null && props.fromIndex >= 0 ? props.fromIndex + 1 : null;

    const [newStep, setNewStep] = useState("");

    // Reset the input to the rule's current step each time the modal opens.
    useEffect(() => {
        if (props.open && currentStep !== null) {
            setNewStep(currentStep.toString());
        }
    }, [props.open, props.fromIndex]);

    const parsedStep = parseInt(newStep, 10);
    const isValid =
        currentStep !== null &&
        !isNaN(parsedStep) &&
        parsedStep >= 1 &&
        parsedStep <= total &&
        parsedStep !== currentStep;

    const confirm = () => {
        if (!isValid) return;
        const toIndex = parsedStep - 1;
        props.setCostRules(prev => arrayMove(prev, props.fromIndex, toIndex));
        props.handleClose();
    };

    return (
        <SHModal
            open={props.open}
            onClose={props.handleClose}
        >
            <Box
                sx={{
                    textAlign: "center",
                    paddingY: 4,
                    paddingX: 5,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                }}
            >
                <Subheading>{t("move_to_step")}</Subheading>
            </Box>
            <Box
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding: 3,
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 3,
                }}
            >
                <Box sx={{ textAlign: "center" }}>
                    <Text light>{t("current_step")}</Text>
                    <Heading>{currentStep}</Heading>
                </Box>
                <ArrowRightAltIcon sx={{ color: colors.txt["secondary"] }} />
                <Box sx={{ textAlign: "center" }}>
                    <Text light>{t("new_step")}</Text>
                    <TextInput
                        autoFocus
                        type="number"
                        value={newStep}
                        width={96}
                        onChange={(e) => setNewStep(e.target.value)}
                        returnOnEnter={(e) => {
                            if (e.key === "Enter") confirm();
                        }}
                    />
                </Box>
            </Box>
            <Box
                component="footer"
                sx={{
                    width: 1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display: "flex",
                    alignItems: "center",
                    paddingRight: 3,
                    zIndex: 1058,
                    position: "relative",
                    paddingTop: 2,
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius: 24,
                    borderBottomRightRadius: 24,
                    justifyContent: "space-between",
                    "@media screen and (max-width: 47.9375em)": {
                        paddingRight: 0,
                    },
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={props.handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon />}>{t("cancel")}</Shbutton>

                <ButtonGroup version={2}>
                    <Shbutton block className={"group-btn"} color={theme.palette.mode === "dark" ? "blue" : "primary"} onClick={confirm} disabled={!isValid} variant="contained">
                        {t("move")}
                    </Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    );
};

export default MMoveCostRule;
